import { TApplicationState } from "../rootReducer";

export const getFieldVisibility = (state: TApplicationState, fieldName: string) => state.usersAnketa.fieldsVisibility[fieldName]?.visible ?? false;